import { createSlice } from "@reduxjs/toolkit";

// Persist across refresh: read from localStorage, fallback to 'test'.
const initialTestProd = localStorage.getItem("testProdView") || "test";

const testProdChangeSlice = createSlice({
  name: "testProdView",
  initialState: initialTestProd,
  reducers: {
    setChangeTestProd: (state, action) => {
      localStorage.setItem("testProdView", action.payload); // persist
      return action.payload;
    },
  },
});
export const { setChangeTestProd } = testProdChangeSlice.actions;
export default testProdChangeSlice.reducer;
